import { keyframes } from '@emotion/react';

import { Box } from '@/shared/ui/layout/Box';

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(0.5); }
  100% { transform: scale(1); }
`;

const LoadingIndicator = ({ animate }: { animate: boolean }) => {
  return (
    <Box
      data-animate={animate}
      data-testid='loading-indicator'
      sx={{
        width: '24px',
        height: '24px',
        backgroundColor: 'gx.highlight',
        animation: animate ? `${pulse} 1s ease-in-out infinite` : undefined
      }}
    />
  );
};

export default LoadingIndicator;
